function FreePriceColumn({ value }) {
  return value ? <i className="fa fa-check text-success"></i> : <i className="fa fa-times text-danger"></i>;
}

export default FreePriceColumn;
